<template>
  <div class="building_container">
    <!-- 큐레이션 미리 보기 -->
    <CurationInfo v-if="showCurationInfo" :curationInfo="curationInfo" @closeCurationInfo="showCurationInfo = false" />
    <!-- 임시저장 완료 -->
    <CancelModal v-if="cancelStatus" />
    <!-- 중간 저장 팝업  -->
    <CommonConfirm
      v-if="cancelCheckStatus"
      :confirmid="'cancelcheckmodal'"
      @close-modal="onCancelCheckStatusConfirmNo"
      @confirm-modal="onCancelCheckStatusConfirmYes"
    >
      <template #contents>
        <div class="stopmodal_body">
          <h3 class="stopmodal_text1">
            등록중인 스페이스를 저장할까요?
          </h3>
        </div>
      </template>
    </CommonConfirm>
    <!-- 스페이스 등록 템플릿 -->
    <SpaceManageSlot :progress="50" :closefn="backPage">
      <template #pagename>
        스페이스 등록
      </template>
      <template #spacestatus>
        매장 인테리어의 주요 소재를 선택해주세요. (최대 3개)
      </template>

      <template #spacebody>
        <ul class="spaceinsert_material_container">
          <li v-for="item in getMaterialList" :key="`material${item.no}`">
            <a
              tabindex="0"
              class="spaceinsert_marterial_item_label cursor"
              :class="{ active: selectMaterial.includes(item.no) }"
              @click="clickMaterial(item.no)"
            >
              {{ item.materialNm }}
            </a>
          </li>
        </ul>
      </template>
    </SpaceManageSlot>
    <!-- Footer -->
    <BuildingManageFooter :rightbtndisabled="rightBtnDisabled" :leftbtnfn="onClickPre" :rightbtnfn="updateCuration">
      <template #footerleft>
        <PreViewSelectCuration
          :color="color"
          :selectkey="['color']"
          :material="bottomMaterialList"
          @click-detailmodal="onClickDetailModal"
        />
      </template>
    </BuildingManageFooter>
  </div>
</template>
<script>
import { checkSubscribe, getCurationInfoApi, setSpaceMaterial, updateConfirmCuration } from '@/service/api/profileApi';
import SpaceManageSlot from '@/slot/SpaceManageSlot.vue';
import CancelModal from '@/components/modal/Space/CancelModal.vue';
import CommonConfirm from '@/components/common/CommonConfirm.vue';
import BuildingManageFooter from '@/components/Building/BuildingManageFooter.vue';
import PreViewSelectCuration from '@/components/Building/PreViewSelectCuration.vue';
import CurationInfo from '@/components/modal/Space/CurationInfo.vue';
export default {
  props: {
    tempsavematerial: {
      type: Function,
      required: false,
      default: null
    },
    linkmyspace: {
      type: Function,
      required: false,
      default: null
    }
  },
  components: {
    SpaceManageSlot,
    CancelModal,
    CommonConfirm,
    BuildingManageFooter,
    PreViewSelectCuration,
    CurationInfo
  },
  created() {
    this.getSpaceCurationInfo();
  },
  data() {
    return {
      cancelStatus: false,
      cancelCheckStatus: false,
      selectSpaceId: localStorage.getItem('spaceId'),
      selectMaterial: [],
      btnLoading: false,
      curationId: null,
      color: null,
      bottomMaterialList: [],
      curationInfo: null,
      showCurationInfo: false
    };
  },
  methods: {
    onClickDetailModal() {
      this.showCurationInfo = true;
    },
    onClickPre() {
      this.$router.push({ name: 'SpaceInsertStoreColorV2' });
    },
    onCancelCheckStatusConfirmNo() {
      this.linkmyspace(this.selectSpaceId);
    },
    async onCancelCheckStatusConfirmYes() {
      const result = await this.tempsavematerial(
        this.selectSpaceId,
        this.selectMaterial.length > 0 ? this.selectMaterial.sort((a, b) => a - b).join(',') : null
      );
      if (result) {
        this.cancelCheckStatus = false;
        this.cancelStatus = true;
      }
    },
    backPage() {
      checkSubscribe(this.selectSpaceId).then(res => {
        const { resultCd, result } = res.data;
        if (resultCd === '0000') {
          if (result === 'S') {
            this.cancelCheckStatus = true;
          } else {
            this.$router.push({ name: 'buildingBridge' }).catch(() => {});
          }
        }
      });
    },
    clickMaterial(no) {
      const findIdx = this.selectMaterial.findIndex(item => item === no);

      if (findIdx > -1) {
        this.selectMaterial.splice(findIdx, 1);
      } else {
        if (this.selectMaterial.length < 3) {
          this.selectMaterial.push(no);
        }
      }
    },
    async getSpaceCurationInfo() {
      try {
        const { data } = await getCurationInfoApi(this.selectSpaceId);

        const { resultCd, result } = data;
        if (resultCd === '0000') {
          this.curationInfo = result;
          const { color, material, curationId } = result;
          this.curationId = curationId;
          this.color = color;
          if (material) {
            this.bottomMaterialList = material;
            material.forEach(ele => {
              const findMaterial = this.$store.getters['curation/getMaterialValue'](ele);
              if (Object.keys(findMaterial).length > 0) {
                this.selectMaterial.push(findMaterial.no);
              } else {
                this.selectMaterial = [];
              }
            });
          }
        } else {
          throw Error('resultCd : ' + resultCd);
        }
      } catch (error) {
        this.selectMaterial = [];
        console.log('스페이스 정보 소재 조회 실패 : ' + error);
      }
    },
    async updateCuration() {
      try {
        this.btnLoading = true;
        const { data: materialData } = await setSpaceMaterial(
          this.selectSpaceId,
          this.selectMaterial.sort((a, b) => a - b).join(',')
        );
        const { resultCd: materialResultCd } = materialData;
        if (materialResultCd === '0000') {
          const { data: confirmCurationData } = await updateConfirmCuration(this.selectSpaceId, this.curationId);
          const { resultCd: confirmCurationResultCd } = confirmCurationData;
          if (confirmCurationResultCd === '0000') {
            this.$router.push({ name: 'SpaceInsertStoreTargetV2' }).catch(() => {});
          } else {
            throw Error('updateConfirmCuration ResultCd : ' + confirmCurationResultCd);
          }
        } else {
          throw Error('setSpaceMaterial ResultCd : ' + materialResultCd);
        }
      } catch (error) {
        console.log('소재 업데이트 Error : ' + error);
      } finally {
        this.btnLoading = false;
      }
    }
  },
  computed: {
    getMaterialList() {
      return this.$store.getters['curation/getCurationMaterial'];
    },
    rightBtnDisabled() {
      if (this.selectMaterial.length > 0) {
        return false || this.btnLoading;
      }
      return true;
    }
  }
};
</script>
<style scoped src="@/assets/css/building/buildingmaterial.css"></style>
